package flagpack.icons.large

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Kazakhstan Flag (32x24dp)
 *
 * - ISO Alpha-2: KZ
 * - ISO Alpha-3: KAZ
 * - ISO Numeric: 398
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Large.Kazakhstan: ImageVector by lazy {
    ImageVector.Builder(
        name = "Kazakhstan:KZ:KAZ:398:Large",
        defaultWidth = 32.dp,
        defaultHeight = 24.dp,
        viewportWidth = 32f,
        viewportHeight = 24f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF4EC7EE)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFFFFE402))) {
                moveTo(4.09f, 23.237f)
                curveTo(4.027f, 23.707f, 4.328f, 24.042f, 4.833f, 24.257f)
                curveTo(5.511f, 24.547f, 6.197f, 24.276f, 6.827f, 23.577f)
                lineTo(6.01f, 22.84f)
                curveTo(5.73f, 23.151f, 5.528f, 23.27f, 5.372f, 23.268f)
                curveTo(5.677f, 23.05f, 6.069f, 22.78f, 6.546f, 22.46f)
                lineTo(6.775f, 22.128f)
                curveTo(6.959f, 21.339f, 6.387f, 20.911f, 5.515f, 20.911f)
                curveTo(5.001f, 20.911f, 4.591f, 21.013f, 4.33f, 21.232f)
                curveTo(3.902f, 21.59f, 3.975f, 22.163f, 4.426f, 22.462f)
                curveTo(4.461f, 22.485f, 4.498f, 22.507f, 4.534f, 22.525f)
                curveTo(4.282f, 22.739f, 4.127f, 22.959f, 4.09f, 23.237f)
                close()
            }
            path(
                stroke = SolidColor(Color(0xFFFFE402)),
                strokeLineWidth = 1.1f
            ) {
                moveTo(4.565f, 22.495f)
                curveTo(4.565f, 22.495f, 4.69f, 22.219f, 4.627f, 22.075f)
            }
            path(fill = SolidColor(Color(0xFFFFE402))) {
                moveTo(8.569f, 23.237f)
                curveTo(8.633f, 23.707f, 8.332f, 24.042f, 7.827f, 24.257f)
                curveTo(7.148f, 24.547f, 6.463f, 24.276f, 5.833f, 23.577f)
                lineTo(6.649f, 22.84f)
                curveTo(6.929f, 23.151f, 7.131f, 23.27f, 7.288f, 23.268f)
                curveTo(6.982f, 23.05f, 6.59f, 22.78f, 6.113f, 22.46f)
                lineTo(5.884f, 22.128f)
                curveTo(5.7f, 21.339f, 6.272f, 20.911f, 7.144f, 20.911f)
                curveTo(7.658f, 20.911f, 8.069f, 21.013f, 8.329f, 21.232f)
                curveTo(8.758f, 21.59f, 8.684f, 22.163f, 8.234f, 22.462f)
                curveTo(8.198f, 22.485f, 8.162f, 22.507f, 8.125f, 22.525f)
                curveTo(8.378f, 22.739f, 8.532f, 22.959f, 8.569f, 23.237f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFE402))) {
                moveTo(8.596f, 22.269f)
                lineTo(7.593f, 22.722f)
                curveTo(7.452f, 22.41f, 7.41f, 22.126f, 7.527f, 21.856f)
                lineTo(8.537f, 22.294f)
                curveTo(8.571f, 22.215f, 8.57f, 22.212f, 8.596f, 22.269f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFE402))) {
                moveTo(4.09f, 0.763f)
                curveTo(4.027f, 0.293f, 4.328f, -0.042f, 4.833f, -0.257f)
                curveTo(5.511f, -0.547f, 6.197f, -0.276f, 6.827f, 0.423f)
                lineTo(6.01f, 1.16f)
                curveTo(5.73f, 0.849f, 5.528f, 0.73f, 5.372f, 0.732f)
                curveTo(5.677f, 0.95f, 6.069f, 1.22f, 6.546f, 1.54f)
                lineTo(6.775f, 1.872f)
                curveTo(6.959f, 2.661f, 6.387f, 3.089f, 5.515f, 3.089f)
                curveTo(5.001f, 3.089f, 4.591f, 2.987f, 4.33f, 2.769f)
                curveTo(3.902f, 2.41f, 3.975f, 1.837f, 4.426f, 1.538f)
                curveTo(4.461f, 1.515f, 4.498f, 1.493f, 4.534f, 1.474f)
                curveTo(4.282f, 1.261f, 4.127f, 1.041f, 4.09f, 0.763f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFE402))) {
                moveTo(8.569f, 0.763f)
                curveTo(8.633f, 0.293f, 8.332f, -0.042f, 7.827f, -0.257f)
                curveTo(7.148f, -0.547f, 6.463f, -0.276f, 5.833f, 0.423f)
                lineTo(6.649f, 1.16f)
                curveTo(6.929f, 0.849f, 7.131f, 0.73f, 7.288f, 0.732f)
                curveTo(6.982f, 0.95f, 6.59f, 1.22f, 6.113f, 1.54f)
                lineTo(5.884f, 1.872f)
                curveTo(5.7f, 2.661f, 6.272f, 3.089f, 7.144f, 3.089f)
                curveTo(7.658f, 3.089f, 8.069f, 2.987f, 8.329f, 2.769f)
                curveTo(8.758f, 2.41f, 8.684f, 1.837f, 8.234f, 1.538f)
                curveTo(8.198f, 1.515f, 8.162f, 1.493f, 8.125f, 1.474f)
                curveTo(8.378f, 1.261f, 8.532f, 1.041f, 8.569f, 0.763f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(5.094f, 20.063f)
                curveTo(4.463f, 20.081f, 4.07f, 20.211f, 4.07f, 20.82f)
                curveTo(4.07f, 21.49f, 4.722f, 21.7f, 5.415f, 21.7f)
                curveTo(6.043f, 21.7f, 6.751f, 21.31f, 6.751f, 20.612f)
                curveTo(6.751f, 20.188f, 6.211f, 19.331f, 4.851f, 17.473f)
                curveTo(4.804f, 17.429f, 4.778f, 17.407f, 4.757f, 17.407f)
                curveTo(4.84f, 17.361f, 4.985f, 17.307f, 5.176f, 17.307f)
                curveTo(5.243f, 17.307f, 5.329f, 17.341f, 5.415f, 17.384f)
                verticalLineTo(18.112f)
                horizontalLineTo(6.855f)
                verticalLineTo(17.562f)
                curveTo(6.855f, 16.941f, 5.936f, 16.207f, 5.176f, 16.207f)
                curveTo(4.513f, 16.207f, 3.981f, 16.522f, 3.711f, 16.976f)
                curveTo(3.444f, 17.425f, 3.648f, 17.856f, 4.031f, 18.198f)
                curveTo(4.601f, 18.984f, 5.043f, 19.634f, 5.32f, 20.062f)
                curveTo(5.218f, 20.061f, 5.162f, 20.061f, 5.094f, 20.063f)
                close()
                moveTo(5.161f, 20.57f)
                curveTo(5.141f, 20.566f, 5.122f, 20.561f, 5.104f, 20.556f)
                curveTo(5.118f, 20.57f, 5.17f, 20.632f, 5.17f, 20.82f)
                curveTo(5.17f, 20.922f, 5.165f, 20.993f, 5.159f, 21.044f)
                curveTo(4.973f, 20.88f, 4.921f, 20.595f, 5.057f, 20.375f)
                lineTo(5.06f, 20.369f)
                lineTo(5.04f, 20.328f)
                curveTo(5.042f, 20.327f, 5.045f, 20.326f, 5.048f, 20.324f)
                curveTo(5.08f, 20.308f, 5.106f, 20.294f, 5.06f, 20.369f)
                lineTo(5.161f, 20.57f)
                close()
                moveTo(5.104f, 20.556f)
                lineTo(5.085f, 20.55f)
                curveTo(5.087f, 20.551f, 5.09f, 20.552f, 5.093f, 20.554f)
                lineTo(5.104f, 20.556f)
                close()
                moveTo(5.651f, 20.612f)
                curveTo(5.651f, 20.594f, 5.644f, 20.582f, 5.633f, 20.576f)
                lineTo(5.64f, 20.583f)
                curveTo(5.647f, 20.598f, 5.651f, 20.608f, 5.651f, 20.612f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.566f, 20.063f)
                curveTo(8.197f, 20.081f, 8.589f, 20.211f, 8.589f, 20.82f)
                curveTo(8.589f, 21.49f, 7.938f, 21.7f, 7.244f, 21.7f)
                curveTo(6.616f, 21.7f, 5.909f, 21.31f, 5.909f, 20.612f)
                curveTo(5.909f, 20.188f, 6.449f, 19.331f, 7.808f, 17.473f)
                curveTo(7.855f, 17.429f, 7.881f, 17.407f, 7.902f, 17.407f)
                curveTo(7.82f, 17.361f, 7.674f, 17.307f, 7.483f, 17.307f)
                curveTo(7.416f, 17.307f, 7.33f, 17.341f, 7.244f, 17.384f)
                verticalLineTo(18.112f)
                horizontalLineTo(5.805f)
                verticalLineTo(17.562f)
                curveTo(5.805f, 16.941f, 6.723f, 16.207f, 7.483f, 16.207f)
                curveTo(8.146f, 16.207f, 8.679f, 16.522f, 8.949f, 16.976f)
                curveTo(9.215f, 17.425f, 9.011f, 17.856f, 8.628f, 18.198f)
                curveTo(8.059f, 18.984f, 7.616f, 19.634f, 7.339f, 20.062f)
                curveTo(7.441f, 20.061f, 7.497f, 20.061f, 7.566f, 20.063f)
                close()
                moveTo(7.498f, 20.57f)
                curveTo(7.518f, 20.566f, 7.537f, 20.561f, 7.555f, 20.556f)
                curveTo(7.542f, 20.57f, 7.489f, 20.632f, 7.489f, 20.82f)
                curveTo(7.489f, 20.922f, 7.494f, 20.993f, 7.501f, 21.044f)
                curveTo(7.686f, 20.88f, 7.738f, 20.595f, 7.602f, 20.375f)
                lineTo(7.599f, 20.369f)
                lineTo(7.62f, 20.328f)
                curveTo(7.617f, 20.327f, 7.614f, 20.326f, 7.611f, 20.324f)
                curveTo(7.579f, 20.308f, 7.553f, 20.294f, 7.599f, 20.369f)
                lineTo(7.498f, 20.57f)
                close()
                moveTo(7.555f, 20.556f)
                lineTo(7.574f, 20.55f)
                curveTo(7.572f, 20.551f, 7.569f, 20.552f, 7.566f, 20.554f)
                lineTo(7.555f, 20.556f)
                close()
                moveTo(7.009f, 20.612f)
                curveTo(7.009f, 20.594f, 7.015f, 20.582f, 7.026f, 20.576f)
                lineTo(7.02f, 20.583f)
                curveTo(7.012f, 20.598f, 7.009f, 20.608f, 7.009f, 20.612f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(5.094f, 13.355f)
                curveTo(4.463f, 13.337f, 4.07f, 13.206f, 4.07f, 12.598f)
                curveTo(4.07f, 11.927f, 4.722f, 11.717f, 5.415f, 11.717f)
                curveTo(6.043f, 11.717f, 6.751f, 12.107f, 6.751f, 12.805f)
                curveTo(6.751f, 13.23f, 6.211f, 14.087f, 4.851f, 15.945f)
                curveTo(4.804f, 15.989f, 4.778f, 16.011f, 4.757f, 16.011f)
                curveTo(4.84f, 16.057f, 4.985f, 16.111f, 5.176f, 16.111f)
                curveTo(5.243f, 16.111f, 5.329f, 16.077f, 5.415f, 16.034f)
                verticalLineTo(15.305f)
                horizontalLineTo(6.855f)
                verticalLineTo(15.855f)
                curveTo(6.855f, 16.477f, 5.936f, 17.211f, 5.176f, 17.211f)
                curveTo(4.513f, 17.211f, 3.981f, 16.895f, 3.711f, 16.441f)
                curveTo(3.444f, 15.993f, 3.648f, 15.562f, 4.031f, 15.219f)
                curveTo(4.601f, 14.434f, 5.043f, 13.783f, 5.32f, 13.356f)
                curveTo(5.218f, 13.357f, 5.162f, 13.357f, 5.094f, 13.355f)
                close()
                moveTo(5.161f, 12.847f)
                curveTo(5.141f, 12.852f, 5.122f, 12.857f, 5.104f, 12.862f)
                curveTo(5.118f, 12.848f, 5.17f, 12.785f, 5.17f, 12.598f)
                curveTo(5.17f, 12.496f, 5.165f, 12.424f, 5.159f, 12.374f)
                curveTo(4.973f, 12.538f, 4.921f, 12.823f, 5.057f, 13.043f)
                lineTo(5.06f, 13.048f)
                lineTo(5.04f, 13.089f)
                curveTo(5.042f, 13.091f, 5.045f, 13.092f, 5.048f, 13.094f)
                curveTo(5.08f, 13.11f, 5.106f, 13.124f, 5.06f, 13.048f)
                lineTo(5.161f, 12.847f)
                close()
                moveTo(5.104f, 12.862f)
                lineTo(5.085f, 12.868f)
                curveTo(5.087f, 12.867f, 5.09f, 12.866f, 5.093f, 12.864f)
                lineTo(5.104f, 12.862f)
                close()
                moveTo(5.651f, 12.805f)
                curveTo(5.651f, 12.824f, 5.644f, 12.835f, 5.633f, 12.841f)
                lineTo(5.64f, 12.834f)
                curveTo(5.647f, 12.819f, 5.651f, 12.809f, 5.651f, 12.805f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.566f, 13.355f)
                curveTo(8.197f, 13.337f, 8.589f, 13.206f, 8.589f, 12.598f)
                curveTo(8.589f, 11.927f, 7.938f, 11.717f, 7.244f, 11.717f)
                curveTo(6.616f, 11.717f, 5.909f, 12.107f, 5.909f, 12.805f)
                curveTo(5.909f, 13.23f, 6.449f, 14.087f, 7.808f, 15.945f)
                curveTo(7.855f, 15.989f, 7.881f, 16.011f, 7.902f, 16.011f)
                curveTo(7.82f, 16.057f, 7.674f, 16.111f, 7.483f, 16.111f)
                curveTo(7.416f, 16.111f, 7.33f, 16.077f, 7.244f, 16.034f)
                verticalLineTo(15.305f)
                horizontalLineTo(5.805f)
                verticalLineTo(15.855f)
                curveTo(5.805f, 16.477f, 6.723f, 17.211f, 7.483f, 17.211f)
                curveTo(8.146f, 17.211f, 8.679f, 16.895f, 8.949f, 16.441f)
                curveTo(9.215f, 15.993f, 9.011f, 15.562f, 8.628f, 15.219f)
                curveTo(8.059f, 14.434f, 7.616f, 13.783f, 7.339f, 13.356f)
                curveTo(7.441f, 13.357f, 7.497f, 13.357f, 7.566f, 13.355f)
                close()
                moveTo(7.498f, 12.847f)
                curveTo(7.518f, 12.852f, 7.537f, 12.857f, 7.555f, 12.862f)
                curveTo(7.542f, 12.848f, 7.489f, 12.785f, 7.489f, 12.598f)
                curveTo(7.489f, 12.496f, 7.494f, 12.424f, 7.501f, 12.374f)
                curveTo(7.686f, 12.538f, 7.738f, 12.823f, 7.602f, 13.043f)
                lineTo(7.599f, 13.048f)
                lineTo(7.62f, 13.089f)
                curveTo(7.617f, 13.091f, 7.614f, 13.092f, 7.611f, 13.094f)
                curveTo(7.579f, 13.11f, 7.553f, 13.124f, 7.599f, 13.048f)
                lineTo(7.498f, 12.847f)
                close()
                moveTo(7.555f, 12.862f)
                lineTo(7.574f, 12.868f)
                curveTo(7.572f, 12.867f, 7.569f, 12.866f, 7.566f, 12.864f)
                lineTo(7.555f, 12.862f)
                close()
                moveTo(7.009f, 12.805f)
                curveTo(7.009f, 12.824f, 7.015f, 12.835f, 7.026f, 12.841f)
                lineTo(7.02f, 12.834f)
                curveTo(7.012f, 12.819f, 7.009f, 12.809f, 7.009f, 12.805f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(5.094f, 10.645f)
                curveTo(4.463f, 10.663f, 4.07f, 10.794f, 4.07f, 11.402f)
                curveTo(4.07f, 12.073f, 4.722f, 12.283f, 5.415f, 12.283f)
                curveTo(6.043f, 12.283f, 6.751f, 11.893f, 6.751f, 11.195f)
                curveTo(6.751f, 10.77f, 6.211f, 9.913f, 4.851f, 8.055f)
                curveTo(4.804f, 8.011f, 4.778f, 7.989f, 4.757f, 7.989f)
                curveTo(4.84f, 7.943f, 4.985f, 7.889f, 5.176f, 7.889f)
                curveTo(5.243f, 7.889f, 5.329f, 7.923f, 5.415f, 7.966f)
                verticalLineTo(8.695f)
                horizontalLineTo(6.855f)
                verticalLineTo(8.145f)
                curveTo(6.855f, 7.523f, 5.936f, 6.789f, 5.176f, 6.789f)
                curveTo(4.513f, 6.789f, 3.981f, 7.105f, 3.711f, 7.559f)
                curveTo(3.444f, 8.007f, 3.648f, 8.438f, 4.031f, 8.781f)
                curveTo(4.601f, 9.566f, 5.043f, 10.217f, 5.32f, 10.644f)
                curveTo(5.218f, 10.643f, 5.162f, 10.643f, 5.094f, 10.645f)
                close()
                moveTo(5.161f, 11.153f)
                curveTo(5.141f, 11.148f, 5.122f, 11.143f, 5.104f, 11.138f)
                curveTo(5.118f, 11.152f, 5.17f, 11.215f, 5.17f, 11.402f)
                curveTo(5.17f, 11.504f, 5.165f, 11.576f, 5.159f, 11.626f)
                curveTo(4.973f, 11.462f, 4.921f, 11.177f, 5.057f, 10.957f)
                lineTo(5.06f, 10.952f)
                lineTo(5.04f, 10.911f)
                curveTo(5.042f, 10.909f, 5.045f, 10.908f, 5.048f, 10.906f)
                curveTo(5.08f, 10.89f, 5.106f, 10.876f, 5.06f, 10.952f)
                lineTo(5.161f, 11.153f)
                close()
                moveTo(5.104f, 11.138f)
                lineTo(5.085f, 11.132f)
                curveTo(5.087f, 11.133f, 5.09f, 11.134f, 5.093f, 11.136f)
                lineTo(5.104f, 11.138f)
                close()
                moveTo(5.651f, 11.195f)
                curveTo(5.651f, 11.176f, 5.644f, 11.165f, 5.633f, 11.159f)
                lineTo(5.64f, 11.166f)
                curveTo(5.647f, 11.181f, 5.651f, 11.191f, 5.651f, 11.195f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.566f, 10.645f)
                curveTo(8.197f, 10.663f, 8.589f, 10.794f, 8.589f, 11.402f)
                curveTo(8.589f, 12.073f, 7.938f, 12.283f, 7.244f, 12.283f)
                curveTo(6.616f, 12.283f, 5.909f, 11.893f, 5.909f, 11.195f)
                curveTo(5.909f, 10.77f, 6.449f, 9.913f, 7.808f, 8.055f)
                curveTo(7.855f, 8.011f, 7.881f, 7.989f, 7.902f, 7.989f)
                curveTo(7.82f, 7.943f, 7.674f, 7.889f, 7.483f, 7.889f)
                curveTo(7.416f, 7.889f, 7.33f, 7.923f, 7.244f, 7.966f)
                verticalLineTo(8.695f)
                horizontalLineTo(5.805f)
                verticalLineTo(8.145f)
                curveTo(5.805f, 7.523f, 6.723f, 6.789f, 7.483f, 6.789f)
                curveTo(8.146f, 6.789f, 8.679f, 7.105f, 8.949f, 7.559f)
                curveTo(9.215f, 8.007f, 9.011f, 8.438f, 8.628f, 8.781f)
                curveTo(8.059f, 9.566f, 7.616f, 10.217f, 7.339f, 10.644f)
                curveTo(7.441f, 10.643f, 7.497f, 10.643f, 7.566f, 10.645f)
                close()
                moveTo(7.498f, 11.153f)
                curveTo(7.518f, 11.148f, 7.537f, 11.143f, 7.555f, 11.138f)
                curveTo(7.542f, 11.152f, 7.489f, 11.215f, 7.489f, 11.402f)
                curveTo(7.489f, 11.504f, 7.494f, 11.576f, 7.501f, 11.626f)
                curveTo(7.686f, 11.462f, 7.738f, 11.177f, 7.602f, 10.957f)
                lineTo(7.599f, 10.952f)
                lineTo(7.62f, 10.911f)
                curveTo(7.617f, 10.909f, 7.614f, 10.908f, 7.611f, 10.906f)
                curveTo(7.579f, 10.89f, 7.553f, 10.876f, 7.599f, 10.952f)
                lineTo(7.498f, 11.153f)
                close()
                moveTo(7.555f, 11.138f)
                lineTo(7.574f, 11.132f)
                curveTo(7.572f, 11.133f, 7.569f, 11.134f, 7.566f, 11.136f)
                lineTo(7.555f, 11.138f)
                close()
                moveTo(7.009f, 11.195f)
                curveTo(7.009f, 11.176f, 7.015f, 11.165f, 7.026f, 11.159f)
                lineTo(7.02f, 11.166f)
                curveTo(7.012f, 11.181f, 7.009f, 11.191f, 7.009f, 11.195f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(5.094f, 3.937f)
                curveTo(4.463f, 3.919f, 4.07f, 3.789f, 4.07f, 3.18f)
                curveTo(4.07f, 2.51f, 4.722f, 2.3f, 5.415f, 2.3f)
                curveTo(6.043f, 2.3f, 6.751f, 2.69f, 6.751f, 3.388f)
                curveTo(6.751f, 3.812f, 6.211f, 4.669f, 4.851f, 6.527f)
                curveTo(4.804f, 6.571f, 4.778f, 6.593f, 4.757f, 6.593f)
                curveTo(4.84f, 6.639f, 4.985f, 6.693f, 5.176f, 6.693f)
                curveTo(5.243f, 6.693f, 5.329f, 6.659f, 5.415f, 6.616f)
                verticalLineTo(5.888f)
                horizontalLineTo(6.855f)
                verticalLineTo(6.438f)
                curveTo(6.855f, 7.059f, 5.936f, 7.793f, 5.176f, 7.793f)
                curveTo(4.513f, 7.793f, 3.981f, 7.477f, 3.711f, 7.024f)
                curveTo(3.444f, 6.575f, 3.648f, 6.144f, 4.031f, 5.802f)
                curveTo(4.601f, 5.016f, 5.043f, 4.366f, 5.32f, 3.938f)
                curveTo(5.218f, 3.939f, 5.162f, 3.939f, 5.094f, 3.937f)
                close()
                moveTo(5.161f, 3.43f)
                curveTo(5.141f, 3.434f, 5.122f, 3.439f, 5.104f, 3.444f)
                curveTo(5.118f, 3.43f, 5.17f, 3.368f, 5.17f, 3.18f)
                curveTo(5.17f, 3.078f, 5.165f, 3.007f, 5.159f, 2.956f)
                curveTo(4.973f, 3.12f, 4.921f, 3.405f, 5.057f, 3.625f)
                lineTo(5.06f, 3.631f)
                lineTo(5.04f, 3.672f)
                curveTo(5.042f, 3.673f, 5.045f, 3.674f, 5.048f, 3.676f)
                curveTo(5.08f, 3.692f, 5.106f, 3.706f, 5.06f, 3.631f)
                lineTo(5.161f, 3.43f)
                close()
                moveTo(5.104f, 3.444f)
                lineTo(5.085f, 3.45f)
                curveTo(5.087f, 3.449f, 5.09f, 3.448f, 5.093f, 3.446f)
                lineTo(5.104f, 3.444f)
                close()
                moveTo(5.651f, 3.388f)
                curveTo(5.651f, 3.406f, 5.644f, 3.418f, 5.633f, 3.424f)
                lineTo(5.64f, 3.417f)
                curveTo(5.647f, 3.402f, 5.651f, 3.392f, 5.651f, 3.388f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.566f, 3.937f)
                curveTo(8.197f, 3.919f, 8.589f, 3.789f, 8.589f, 3.18f)
                curveTo(8.589f, 2.51f, 7.938f, 2.3f, 7.244f, 2.3f)
                curveTo(6.616f, 2.3f, 5.909f, 2.69f, 5.909f, 3.388f)
                curveTo(5.909f, 3.812f, 6.449f, 4.669f, 7.808f, 6.527f)
                curveTo(7.855f, 6.571f, 7.881f, 6.593f, 7.902f, 6.593f)
                curveTo(7.82f, 6.639f, 7.674f, 6.693f, 7.483f, 6.693f)
                curveTo(7.416f, 6.693f, 7.33f, 6.659f, 7.244f, 6.616f)
                verticalLineTo(5.888f)
                horizontalLineTo(5.805f)
                verticalLineTo(6.438f)
                curveTo(5.805f, 7.059f, 6.723f, 7.793f, 7.483f, 7.793f)
                curveTo(8.146f, 7.793f, 8.679f, 7.477f, 8.949f, 7.024f)
                curveTo(9.215f, 6.575f, 9.011f, 6.144f, 8.628f, 5.802f)
                curveTo(8.059f, 5.016f, 7.616f, 4.366f, 7.339f, 3.938f)
                curveTo(7.441f, 3.939f, 7.497f, 3.939f, 7.566f, 3.937f)
                close()
                moveTo(7.498f, 3.43f)
                curveTo(7.518f, 3.434f, 7.537f, 3.439f, 7.555f, 3.444f)
                curveTo(7.542f, 3.43f, 7.489f, 3.368f, 7.489f, 3.18f)
                curveTo(7.489f, 3.078f, 7.494f, 3.007f, 7.501f, 2.956f)
                curveTo(7.686f, 3.12f, 7.738f, 3.405f, 7.602f, 3.625f)
                lineTo(7.599f, 3.631f)
                lineTo(7.62f, 3.672f)
                curveTo(7.617f, 3.673f, 7.614f, 3.674f, 7.611f, 3.676f)
                curveTo(7.579f, 3.692f, 7.553f, 3.706f, 7.599f, 3.631f)
                lineTo(7.498f, 3.43f)
                close()
                moveTo(7.555f, 3.444f)
                lineTo(7.574f, 3.45f)
                curveTo(7.572f, 3.449f, 7.569f, 3.448f, 7.566f, 3.446f)
                lineTo(7.555f, 3.444f)
                close()
                moveTo(7.009f, 3.388f)
                curveTo(7.009f, 3.406f, 7.015f, 3.418f, 7.026f, 3.424f)
                lineTo(7.02f, 3.417f)
                curveTo(7.012f, 3.402f, 7.009f, 3.392f, 7.009f, 3.388f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(18.987f, 2.785f)
                lineTo(19.396f, 4.313f)
                curveTo(19.396f, 4.313f, 19.401f, 4.66f, 19.009f, 4.66f)
                curveTo(18.617f, 4.66f, 18.597f, 4.313f, 18.597f, 4.313f)
                lineTo(18.987f, 2.785f)
                close()
                moveTo(22.45f, 8.62f)
                curveTo(22.45f, 10.608f, 20.933f, 12.22f, 19.06f, 12.22f)
                curveTo(17.188f, 12.22f, 15.67f, 10.608f, 15.67f, 8.62f)
                curveTo(15.67f, 6.632f, 17.188f, 5.02f, 19.06f, 5.02f)
                curveTo(20.933f, 5.02f, 22.45f, 6.632f, 22.45f, 8.62f)
                close()
                moveTo(20.581f, 4.621f)
                lineTo(20.636f, 3.04f)
                lineTo(19.817f, 4.387f)
                curveTo(19.817f, 4.387f, 19.734f, 4.725f, 20.109f, 4.839f)
                curveTo(20.484f, 4.954f, 20.581f, 4.621f, 20.581f, 4.621f)
                close()
                moveTo(22.141f, 3.788f)
                lineTo(21.626f, 5.284f)
                curveTo(21.626f, 5.284f, 21.436f, 5.574f, 21.111f, 5.355f)
                curveTo(20.785f, 5.136f, 20.963f, 4.837f, 20.963f, 4.837f)
                lineTo(22.141f, 3.788f)
                close()
                moveTo(22.437f, 6.244f)
                lineTo(23.366f, 4.964f)
                lineTo(21.934f, 5.623f)
                curveTo(21.934f, 5.623f, 21.677f, 5.856f, 21.923f, 6.161f)
                curveTo(22.17f, 6.466f, 22.437f, 6.244f, 22.437f, 6.244f)
                close()
                moveTo(24.211f, 6.478f)
                lineTo(22.931f, 7.407f)
                curveTo(22.931f, 7.407f, 22.609f, 7.536f, 22.469f, 7.17f)
                curveTo(22.328f, 6.804f, 22.645f, 6.661f, 22.645f, 6.661f)
                lineTo(24.211f, 6.478f)
                close()
                moveTo(23.088f, 8.682f)
                lineTo(24.583f, 8.167f)
                lineTo(23.032f, 7.885f)
                curveTo(23.032f, 7.885f, 22.687f, 7.929f, 22.715f, 8.32f)
                curveTo(22.742f, 8.711f, 23.088f, 8.682f, 23.088f, 8.682f)
                close()
                moveTo(24.46f, 9.896f)
                lineTo(22.88f, 9.951f)
                curveTo(22.88f, 9.951f, 22.541f, 9.878f, 22.629f, 9.496f)
                curveTo(22.717f, 9.114f, 23.06f, 9.173f, 23.06f, 9.173f)
                lineTo(24.46f, 9.896f)
                close()
                moveTo(22.326f, 11.101f)
                lineTo(23.854f, 11.51f)
                lineTo(22.725f, 10.409f)
                curveTo(22.725f, 10.409f, 22.415f, 10.253f, 22.219f, 10.592f)
                curveTo(22.023f, 10.932f, 22.326f, 11.101f, 22.326f, 11.101f)
                close()
                moveTo(22.816f, 12.868f)
                lineTo(21.475f, 12.03f)
                curveTo(21.475f, 12.03f, 21.235f, 11.779f, 21.521f, 11.512f)
                curveTo(21.808f, 11.244f, 22.059f, 11.485f, 22.059f, 11.485f)
                lineTo(22.816f, 12.868f)
                close()
                moveTo(20.403f, 12.654f)
                lineTo(21.441f, 13.847f)
                lineTo(21.121f, 12.303f)
                curveTo(21.121f, 12.303f, 20.951f, 12f, 20.599f, 12.172f)
                curveTo(20.246f, 12.344f, 20.403f, 12.654f, 20.403f, 12.654f)
                close()
                moveTo(19.848f, 14.363f)
                lineTo(19.205f, 12.918f)
                curveTo(19.205f, 12.918f, 19.146f, 12.576f, 19.533f, 12.514f)
                curveTo(19.92f, 12.453f, 19.994f, 12.793f, 19.994f, 12.793f)
                lineTo(19.848f, 14.363f)
                close()
                moveTo(17.999f, 12.793f)
                lineTo(18.164f, 14.366f)
                lineTo(18.788f, 12.918f)
                curveTo(18.788f, 12.918f, 18.823f, 12.572f, 18.436f, 12.511f)
                curveTo(18.049f, 12.449f, 17.999f, 12.793f, 17.999f, 12.793f)
                close()
                moveTo(16.57f, 13.856f)
                lineTo(16.872f, 12.303f)
                curveTo(16.872f, 12.303f, 17.02f, 11.989f, 17.372f, 12.161f)
                curveTo(17.725f, 12.333f, 17.59f, 12.654f, 17.59f, 12.654f)
                lineTo(16.57f, 13.856f)
                close()
                moveTo(15.934f, 11.485f)
                lineTo(15.191f, 12.881f)
                lineTo(16.518f, 12.03f)
                curveTo(16.518f, 12.03f, 16.74f, 11.762f, 16.454f, 11.495f)
                curveTo(16.167f, 11.227f, 15.934f, 11.485f, 15.934f, 11.485f)
                close()
                moveTo(14.149f, 11.528f)
                lineTo(15.268f, 10.409f)
                curveTo(15.268f, 10.409f, 15.566f, 10.231f, 15.762f, 10.571f)
                curveTo(15.958f, 10.91f, 15.667f, 11.101f, 15.667f, 11.101f)
                lineTo(14.149f, 11.528f)
                close()
                moveTo(14.934f, 9.173f)
                lineTo(13.537f, 9.915f)
                lineTo(15.113f, 9.951f)
                curveTo(15.113f, 9.951f, 15.447f, 9.854f, 15.359f, 9.472f)
                curveTo(15.271f, 9.09f, 14.934f, 9.173f, 14.934f, 9.173f)
                close()
                moveTo(13.408f, 8.187f)
                lineTo(14.961f, 7.885f)
                curveTo(14.961f, 7.885f, 15.308f, 7.905f, 15.28f, 8.296f)
                curveTo(15.253f, 8.687f, 14.905f, 8.682f, 14.905f, 8.682f)
                lineTo(13.408f, 8.187f)
                close()
                moveTo(15.348f, 6.661f)
                lineTo(13.775f, 6.496f)
                lineTo(15.062f, 7.407f)
                curveTo(15.062f, 7.407f, 15.393f, 7.513f, 15.533f, 7.147f)
                curveTo(15.674f, 6.781f, 15.348f, 6.661f, 15.348f, 6.661f)
                close()
                moveTo(14.614f, 4.979f)
                lineTo(16.059f, 5.623f)
                curveTo(16.059f, 5.623f, 16.332f, 5.837f, 16.085f, 6.142f)
                curveTo(15.839f, 6.447f, 15.556f, 6.244f, 15.556f, 6.244f)
                lineTo(14.614f, 4.979f)
                close()
                moveTo(17.03f, 4.837f)
                lineTo(15.836f, 3.799f)
                lineTo(16.367f, 5.284f)
                curveTo(16.367f, 5.284f, 16.578f, 5.561f, 16.903f, 5.341f)
                curveTo(17.228f, 5.122f, 17.03f, 4.837f, 17.03f, 4.837f)
                close()
                moveTo(17.338f, 3.046f)
                lineTo(18.176f, 4.387f)
                curveTo(18.176f, 4.387f, 18.282f, 4.717f, 17.907f, 4.832f)
                curveTo(17.532f, 4.947f, 17.412f, 4.621f, 17.412f, 4.621f)
                lineTo(17.338f, 3.046f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(12.221f, 10.672f)
                curveTo(12.207f, 10.619f, 12.195f, 10.568f, 12.183f, 10.518f)
                lineTo(12.253f, 10.659f)
                lineTo(12.221f, 10.672f)
                close()
                moveTo(12.317f, 11.002f)
                curveTo(12.28f, 10.887f, 12.248f, 10.777f, 12.221f, 10.672f)
                lineTo(11.792f, 10.843f)
                lineTo(11.856f, 11.002f)
                horizontalLineTo(11.81f)
                lineTo(11.792f, 11.011f)
                curveTo(11.766f, 10.88f, 11.753f, 10.757f, 11.753f, 10.639f)
                verticalLineTo(9.652f)
                lineTo(12.183f, 10.518f)
                curveTo(12.129f, 10.278f, 12.101f, 10.066f, 12.101f, 9.881f)
                verticalLineTo(8.651f)
                lineTo(12.599f, 9.898f)
                lineTo(12.127f, 10.046f)
                lineTo(12.312f, 10.639f)
                horizontalLineTo(12.303f)
                lineTo(12.253f, 10.659f)
                lineTo(12.43f, 11.014f)
                lineTo(12.6f, 11.557f)
                curveTo(12.441f, 11.265f, 12.36f, 11.071f, 12.36f, 11.002f)
                horizontalLineTo(12.317f)
                close()
                moveTo(12.864f, 12.389f)
                curveTo(12.626f, 11.861f, 12.444f, 11.401f, 12.317f, 11.002f)
                horizontalLineTo(11.856f)
                lineTo(12.324f, 12.175f)
                lineTo(12.151f, 11.99f)
                curveTo(11.969f, 11.626f, 11.849f, 11.302f, 11.792f, 11.011f)
                lineTo(11.41f, 11.2f)
                lineTo(11.335f, 11.119f)
                verticalLineTo(11.238f)
                lineTo(11.317f, 11.247f)
                lineTo(11.335f, 11.282f)
                verticalLineTo(11.416f)
                curveTo(11.285f, 11.26f, 11.26f, 11.123f, 11.26f, 11.002f)
                verticalLineTo(8.658f)
                lineTo(11.753f, 9.652f)
                verticalLineTo(7.778f)
                lineTo(12.101f, 8.651f)
                verticalLineTo(6.283f)
                lineTo(13.492f, 10.726f)
                lineTo(13.394f, 10.758f)
                curveTo(13.266f, 10.373f, 13.201f, 10.078f, 13.201f, 9.881f)
                horizontalLineTo(12.651f)
                lineTo(12.599f, 9.898f)
                lineTo(12.995f, 10.888f)
                lineTo(12.899f, 10.919f)
                curveTo(12.868f, 10.81f, 12.853f, 10.716f, 12.853f, 10.639f)
                horizontalLineTo(12.312f)
                lineTo(12.43f, 11.014f)
                lineTo(13.044f, 12.25f)
                lineTo(13.018f, 12.26f)
                curveTo(12.845f, 11.988f, 12.705f, 11.751f, 12.6f, 11.557f)
                lineTo(12.841f, 12.328f)
                lineTo(13.018f, 12.26f)
                lineTo(13.043f, 12.299f)
                lineTo(12.864f, 12.389f)
                close()
                moveTo(13.055f, 12.317f)
                lineTo(12.864f, 12.389f)
                lineTo(12.864f, 12.389f)
                lineTo(12.633f, 12.505f)
                lineTo(12.324f, 12.175f)
                lineTo(12.471f, 12.543f)
                curveTo(12.454f, 12.529f, 12.443f, 12.519f, 12.438f, 12.514f)
                curveTo(12.33f, 12.331f, 12.234f, 12.156f, 12.151f, 11.99f)
                lineTo(11.41f, 11.2f)
                lineTo(11.335f, 11.238f)
                verticalLineTo(11.282f)
                lineTo(11.945f, 12.51f)
                horizontalLineTo(11.884f)
                lineTo(11.88f, 12.514f)
                curveTo(11.609f, 12.066f, 11.428f, 11.707f, 11.335f, 11.416f)
                verticalLineTo(12.219f)
                lineTo(9.15f, 10.663f)
                lineTo(11.932f, 13.974f)
                curveTo(12.821f, 15.032f, 13.917f, 15.845f, 15.213f, 16.41f)
                lineTo(12.693f, 16.357f)
                lineTo(15.254f, 17.08f)
                lineTo(13.929f, 18.055f)
                lineTo(16.217f, 17.352f)
                lineTo(16.841f, 17.528f)
                curveTo(17.681f, 17.765f, 18.149f, 18.002f, 18.179f, 18.075f)
                lineTo(18.297f, 18.353f)
                lineTo(18.595f, 18.403f)
                curveTo(19.249f, 18.512f, 20.455f, 18.342f, 22.009f, 17.998f)
                curveTo(22.537f, 17.881f, 23.067f, 17.75f, 23.477f, 17.64f)
                curveTo(23.649f, 17.593f, 23.784f, 17.555f, 23.859f, 17.53f)
                curveTo(23.891f, 17.519f, 23.891f, 17.519f, 23.931f, 17.504f)
                lineTo(23.931f, 17.504f)
                curveTo(23.956f, 17.494f, 23.956f, 17.494f, 24.015f, 17.462f)
                lineTo(24.015f, 17.462f)
                lineTo(24.015f, 17.462f)
                curveTo(24.065f, 17.455f, 24.102f, 17.45f, 24.127f, 17.43f)
                curveTo(24.195f, 17.374f, 24.17f, 17.204f, 24.076f, 16.56f)
                lineTo(24.076f, 16.56f)
                curveTo(23.642f, 16.444f, 23.582f, 16.428f, 23.566f, 16.448f)
                curveTo(23.563f, 16.451f, 23.562f, 16.455f, 23.56f, 16.46f)
                curveTo(23.411f, 16.491f, 23.179f, 16.487f, 22.871f, 16.447f)
                curveTo(25.456f, 15.176f, 27.155f, 13.902f, 27.969f, 12.591f)
                lineTo(29.457f, 10.193f)
                lineTo(28.555f, 10.851f)
                lineTo(28.88f, 9.807f)
                lineTo(27.595f, 10.632f)
                curveTo(27.761f, 10.413f, 27.889f, 10.195f, 27.979f, 9.976f)
                lineTo(28.947f, 7.637f)
                lineTo(27.419f, 9.062f)
                lineTo(28.248f, 6.33f)
                lineTo(26.282f, 8.964f)
                lineTo(18.232f, 14.888f)
                lineTo(18.107f, 14.859f)
                curveTo(16.125f, 14.4f, 14.734f, 13f, 13.906f, 10.592f)
                lineTo(13.492f, 10.726f)
                lineTo(13.498f, 10.743f)
                lineTo(13.4f, 10.775f)
                lineTo(13.394f, 10.758f)
                lineTo(12.995f, 10.888f)
                lineTo(13.002f, 10.905f)
                lineTo(12.904f, 10.937f)
                lineTo(12.899f, 10.919f)
                lineTo(12.86f, 10.932f)
                curveTo(12.993f, 11.367f, 13.139f, 11.774f, 13.298f, 12.154f)
                lineTo(13.044f, 12.25f)
                lineTo(13.063f, 12.289f)
                lineTo(13.043f, 12.299f)
                lineTo(13.055f, 12.317f)
                close()
                moveTo(13.073f, 12.31f)
                lineTo(13.055f, 12.317f)
                lineTo(13.094f, 12.378f)
                lineTo(12.7f, 12.576f)
                lineTo(12.633f, 12.505f)
                lineTo(12.504f, 12.569f)
                curveTo(12.491f, 12.559f, 12.48f, 12.551f, 12.471f, 12.543f)
                lineTo(12.485f, 12.578f)
                lineTo(12.504f, 12.569f)
                curveTo(12.526f, 12.586f, 12.555f, 12.607f, 12.591f, 12.63f)
                lineTo(12.527f, 12.662f)
                curveTo(12.497f, 12.612f, 12.467f, 12.563f, 12.438f, 12.514f)
                lineTo(12.434f, 12.51f)
                horizontalLineTo(11.945f)
                lineTo(12.055f, 12.733f)
                lineTo(11.983f, 12.682f)
                curveTo(11.948f, 12.625f, 11.913f, 12.569f, 11.88f, 12.514f)
                lineTo(11.823f, 12.568f)
                lineTo(11.335f, 12.219f)
                verticalLineTo(12.51f)
                curveTo(11.335f, 13.031f, 11.701f, 13.424f, 12.33f, 13.748f)
                lineTo(12.034f, 14.068f)
                lineTo(15.325f, 16.413f)
                lineTo(15.213f, 16.41f)
                curveTo(15.321f, 16.458f, 15.43f, 16.503f, 15.54f, 16.546f)
                lineTo(15.826f, 16.659f)
                lineTo(15.254f, 17.08f)
                lineTo(16.217f, 17.352f)
                lineTo(16.986f, 17.116f)
                lineTo(19.719f, 18.192f)
                lineTo(18.837f, 17.564f)
                curveTo(18.945f, 17.563f, 19.049f, 17.562f, 19.151f, 17.56f)
                curveTo(19.108f, 17.482f, 19.053f, 17.407f, 18.986f, 17.336f)
                curveTo(18.906f, 17.333f, 18.835f, 17.328f, 18.776f, 17.318f)
                lineTo(18.746f, 17.499f)
                lineTo(17.825f, 16.843f)
                curveTo(18.177f, 16.722f, 18.52f, 16.594f, 18.852f, 16.461f)
                curveTo(20.216f, 16.446f, 21.033f, 16.373f, 21.155f, 16.283f)
                lineTo(21.365f, 16.127f)
                lineTo(21.619f, 16.192f)
                curveTo(21.864f, 16.255f, 22.089f, 16.307f, 22.294f, 16.349f)
                lineTo(22.468f, 16.642f)
                curveTo(22.605f, 16.577f, 22.739f, 16.512f, 22.871f, 16.447f)
                curveTo(22.838f, 16.443f, 22.804f, 16.439f, 22.77f, 16.434f)
                lineTo(27.826f, 12.745f)
                lineTo(27.403f, 12.353f)
                curveTo(27.938f, 12.077f, 28.287f, 11.715f, 28.431f, 11.25f)
                lineTo(28.555f, 10.851f)
                lineTo(28.01f, 11.249f)
                lineTo(27.906f, 11.086f)
                lineTo(27.381f, 10.923f)
                curveTo(27.333f, 11.079f, 27.174f, 11.235f, 26.894f, 11.378f)
                curveTo(27.175f, 11.128f, 27.409f, 10.88f, 27.595f, 10.632f)
                lineTo(26.801f, 11.143f)
                lineTo(27.846f, 10.168f)
                lineTo(27.194f, 9.716f)
                curveTo(27.251f, 9.588f, 27.298f, 9.461f, 27.336f, 9.336f)
                lineTo(27.419f, 9.062f)
                lineTo(27.051f, 9.405f)
                lineTo(26.504f, 9.128f)
                lineTo(26.757f, 8.615f)
                lineTo(26.282f, 8.964f)
                lineTo(25.157f, 10.472f)
                lineTo(24.774f, 10.151f)
                curveTo(23.746f, 12.236f, 21.896f, 13.892f, 19.206f, 15.114f)
                lineTo(18.232f, 14.888f)
                lineTo(17.954f, 15.093f)
                lineTo(17.982f, 14.845f)
                curveTo(16.148f, 14.845f, 14.796f, 13.485f, 13.911f, 10.609f)
                lineTo(13.498f, 10.743f)
                lineTo(13.891f, 11.999f)
                lineTo(13.498f, 12.148f)
                lineTo(13.474f, 12.087f)
                lineTo(13.867f, 11.937f)
                curveTo(13.665f, 11.49f, 13.51f, 11.101f, 13.4f, 10.775f)
                lineTo(13.002f, 10.905f)
                lineTo(13.474f, 12.087f)
                lineTo(13.44f, 12.1f)
                lineTo(13.465f, 12.087f)
                curveTo(13.172f, 11.61f, 12.988f, 11.221f, 12.904f, 10.937f)
                lineTo(12.865f, 10.949f)
                curveTo(13.01f, 11.369f, 13.171f, 11.764f, 13.349f, 12.134f)
                lineTo(13.298f, 12.154f)
                lineTo(13.304f, 12.168f)
                lineTo(13.063f, 12.289f)
                lineTo(13.073f, 12.31f)
                close()
                moveTo(13.323f, 12.215f)
                lineTo(13.073f, 12.31f)
                lineTo(13.104f, 12.373f)
                lineTo(13.094f, 12.378f)
                lineTo(13.132f, 12.436f)
                lineTo(12.765f, 12.646f)
                lineTo(12.7f, 12.576f)
                lineTo(12.591f, 12.63f)
                curveTo(12.619f, 12.648f, 12.651f, 12.668f, 12.688f, 12.69f)
                lineTo(12.304f, 12.91f)
                lineTo(12.055f, 12.733f)
                lineTo(12.179f, 12.981f)
                lineTo(12.304f, 12.91f)
                lineTo(12.361f, 12.951f)
                lineTo(12.211f, 13.037f)
                curveTo(12.13f, 12.913f, 12.054f, 12.795f, 11.983f, 12.682f)
                lineTo(11.823f, 12.568f)
                lineTo(11.483f, 12.886f)
                lineTo(12.189f, 13.639f)
                lineTo(12.59f, 13.263f)
                lineTo(12.646f, 13.154f)
                lineTo(14.439f, 14.431f)
                lineTo(15.101f, 15.138f)
                curveTo(14.199f, 14.664f, 13.424f, 14.04f, 12.774f, 13.267f)
                lineTo(12.33f, 13.748f)
                lineTo(12.34f, 13.753f)
                lineTo(15.146f, 15.185f)
                lineTo(15.101f, 15.138f)
                curveTo(15.371f, 15.28f, 15.651f, 15.408f, 15.943f, 15.523f)
                lineTo(15.459f, 16.416f)
                lineTo(15.325f, 16.413f)
                lineTo(15.423f, 16.483f)
                lineTo(15.459f, 16.416f)
                lineTo(16.137f, 16.43f)
                lineTo(15.826f, 16.659f)
                lineTo(16.986f, 17.116f)
                lineTo(17.026f, 17.103f)
                curveTo(17.298f, 17.02f, 17.564f, 16.933f, 17.825f, 16.843f)
                lineTo(17.625f, 16.701f)
                lineTo(17.949f, 16.462f)
                curveTo(18.272f, 16.464f, 18.573f, 16.464f, 18.852f, 16.461f)
                curveTo(19.258f, 16.298f, 19.649f, 16.126f, 20.025f, 15.945f)
                horizontalLineTo(22.053f)
                lineTo(22.294f, 16.349f)
                curveTo(22.34f, 16.358f, 22.385f, 16.367f, 22.429f, 16.376f)
                lineTo(22.556f, 16.589f)
                lineTo(22.77f, 16.434f)
                curveTo(22.664f, 16.418f, 22.551f, 16.399f, 22.429f, 16.376f)
                lineTo(22.173f, 15.945f)
                horizontalLineTo(22.79f)
                lineTo(22.074f, 15.779f)
                lineTo(21.996f, 15.648f)
                curveTo(24.124f, 14.637f, 25.628f, 13.645f, 26.508f, 12.691f)
                curveTo(26.848f, 12.597f, 27.146f, 12.484f, 27.403f, 12.353f)
                lineTo(27.219f, 12.182f)
                lineTo(28.204f, 11.549f)
                lineTo(28.01f, 11.249f)
                lineTo(26.35f, 12.46f)
                lineTo(26.143f, 11.975f)
                curveTo(26.423f, 11.774f, 26.673f, 11.576f, 26.894f, 11.378f)
                curveTo(26.737f, 11.459f, 26.542f, 11.535f, 26.306f, 11.605f)
                lineTo(26.801f, 11.143f)
                lineTo(25.296f, 12.11f)
                curveTo(26.234f, 11.244f, 26.869f, 10.452f, 27.194f, 9.716f)
                lineTo(27.128f, 9.67f)
                lineTo(27.25f, 9.506f)
                lineTo(27.051f, 9.405f)
                lineTo(25.786f, 10.586f)
                lineTo(26.504f, 9.128f)
                lineTo(26.283f, 9.017f)
                curveTo(26.149f, 9.461f, 25.815f, 9.983f, 25.278f, 10.573f)
                lineTo(25.157f, 10.472f)
                lineTo(24.478f, 11.38f)
                lineTo(24.647f, 11.533f)
                lineTo(19.643f, 15.215f)
                lineTo(19.206f, 15.114f)
                curveTo(18.788f, 15.304f, 18.349f, 15.483f, 17.89f, 15.652f)
                lineTo(17.954f, 15.093f)
                lineTo(17.112f, 15.712f)
                curveTo(15.498f, 15.135f, 14.255f, 13.965f, 13.395f, 12.227f)
                lineTo(13.507f, 12.171f)
                lineTo(13.498f, 12.148f)
                lineTo(13.378f, 12.194f)
                lineTo(13.354f, 12.143f)
                lineTo(13.44f, 12.1f)
                lineTo(13.349f, 12.134f)
                lineTo(13.354f, 12.143f)
                lineTo(13.304f, 12.168f)
                lineTo(13.323f, 12.215f)
                close()
                moveTo(13.34f, 12.254f)
                lineTo(13.104f, 12.373f)
                lineTo(13.164f, 12.492f)
                lineTo(12.811f, 12.694f)
                lineTo(12.765f, 12.646f)
                lineTo(12.688f, 12.69f)
                curveTo(12.708f, 12.702f, 12.73f, 12.714f, 12.753f, 12.727f)
                lineTo(12.361f, 12.951f)
                lineTo(12.646f, 13.154f)
                lineTo(12.84f, 12.773f)
                curveTo(12.809f, 12.757f, 12.78f, 12.742f, 12.753f, 12.727f)
                lineTo(12.811f, 12.694f)
                lineTo(14.439f, 14.431f)
                lineTo(16.682f, 16.029f)
                lineTo(16.137f, 16.43f)
                lineTo(16.902f, 16.446f)
                lineTo(17.191f, 17.02f)
                lineTo(17.625f, 16.701f)
                lineTo(17.278f, 16.454f)
                curveTo(17.511f, 16.458f, 17.735f, 16.461f, 17.949f, 16.462f)
                lineTo(18.652f, 15.945f)
                horizontalLineTo(20.025f)
                curveTo(20.32f, 15.803f, 20.606f, 15.655f, 20.882f, 15.503f)
                lineTo(21.935f, 15.747f)
                lineTo(22.053f, 15.945f)
                horizontalLineTo(22.173f)
                lineTo(22.074f, 15.779f)
                lineTo(21.935f, 15.747f)
                lineTo(21.908f, 15.701f)
                lineTo(25.788f, 12.87f)
                lineTo(26.277f, 12.751f)
                curveTo(26.356f, 12.732f, 26.433f, 12.712f, 26.508f, 12.691f)
                curveTo(26.546f, 12.65f, 26.583f, 12.609f, 26.619f, 12.567f)
                lineTo(27.219f, 12.182f)
                lineTo(27.034f, 12.011f)
                curveTo(26.92f, 12.195f, 26.782f, 12.38f, 26.619f, 12.567f)
                lineTo(26.444f, 12.68f)
                lineTo(26.35f, 12.46f)
                lineTo(25.788f, 12.87f)
                lineTo(23.796f, 13.354f)
                curveTo(24.019f, 13.132f, 24.23f, 12.903f, 24.429f, 12.667f)
                lineTo(25.067f, 12.257f)
                lineTo(25.284f, 12.543f)
                curveTo(25.596f, 12.352f, 25.882f, 12.163f, 26.143f, 11.975f)
                lineTo(26.076f, 11.819f)
                lineTo(26.306f, 11.605f)
                curveTo(26.215f, 11.632f, 26.119f, 11.658f, 26.017f, 11.682f)
                lineTo(26.076f, 11.819f)
                lineTo(25.371f, 12.477f)
                lineTo(25.159f, 12.198f)
                lineTo(25.291f, 12.113f)
                lineTo(25.292f, 12.114f)
                lineTo(25.296f, 12.11f)
                lineTo(25.291f, 12.113f)
                lineTo(25.031f, 11.879f)
                curveTo(25.051f, 11.851f, 25.07f, 11.823f, 25.089f, 11.794f)
                lineTo(25.36f, 12.038f)
                lineTo(27.128f, 9.67f)
                lineTo(26.962f, 9.556f)
                curveTo(26.784f, 9.988f, 26.312f, 10.493f, 25.545f, 11.05f)
                curveTo(25.62f, 10.914f, 25.691f, 10.777f, 25.76f, 10.637f)
                lineTo(25.786f, 10.586f)
                lineTo(25.552f, 10.803f)
                lineTo(25.278f, 10.573f)
                curveTo(25.066f, 10.807f, 24.822f, 11.051f, 24.546f, 11.305f)
                lineTo(24.731f, 11.472f)
                lineTo(24.647f, 11.533f)
                lineTo(24.71f, 11.589f)
                lineTo(24.621f, 11.672f)
                lineTo(24.91f, 12.052f)
                curveTo(24.758f, 12.262f, 24.598f, 12.467f, 24.429f, 12.667f)
                lineTo(23.097f, 13.523f)
                lineTo(23.796f, 13.354f)
                curveTo(22.984f, 14.161f, 22.012f, 14.877f, 20.882f, 15.503f)
                lineTo(19.643f, 15.215f)
                lineTo(18.652f, 15.945f)
                horizontalLineTo(17.982f)
                curveTo(17.722f, 15.945f, 17.471f, 15.925f, 17.227f, 15.884f)
                curveTo(17.294f, 15.862f, 17.361f, 15.839f, 17.428f, 15.816f)
                curveTo(17.569f, 15.859f, 17.712f, 15.897f, 17.858f, 15.931f)
                lineTo(17.89f, 15.652f)
                curveTo(17.738f, 15.708f, 17.584f, 15.763f, 17.428f, 15.816f)
                curveTo(17.321f, 15.784f, 17.216f, 15.749f, 17.112f, 15.712f)
                lineTo(16.953f, 15.83f)
                curveTo(15.404f, 15.468f, 14.198f, 14.258f, 13.34f, 12.254f)
                close()
                moveTo(13.34f, 12.254f)
                lineTo(13.395f, 12.227f)
                lineTo(13.378f, 12.194f)
                lineTo(13.323f, 12.215f)
                lineTo(13.34f, 12.254f)
                close()
                moveTo(16.711f, 16.049f)
                lineTo(16.682f, 16.029f)
                lineTo(16.953f, 15.83f)
                curveTo(17.043f, 15.851f, 17.134f, 15.869f, 17.227f, 15.884f)
                curveTo(17.057f, 15.941f, 16.885f, 15.996f, 16.711f, 16.049f)
                close()
                moveTo(24.976f, 11.958f)
                curveTo(24.995f, 11.932f, 25.013f, 11.905f, 25.031f, 11.879f)
                lineTo(24.72f, 11.599f)
                curveTo(24.75f, 11.58f, 24.78f, 11.561f, 24.81f, 11.543f)
                lineTo(25.089f, 11.794f)
                curveTo(25.252f, 11.553f, 25.404f, 11.304f, 25.545f, 11.05f)
                curveTo(25.324f, 11.21f, 25.079f, 11.375f, 24.81f, 11.543f)
                lineTo(24.784f, 11.52f)
                lineTo(25.23f, 11.105f)
                lineTo(25.593f, 10.837f)
                lineTo(25.552f, 10.803f)
                lineTo(25.23f, 11.105f)
                lineTo(24.731f, 11.472f)
                lineTo(24.784f, 11.52f)
                lineTo(24.71f, 11.589f)
                lineTo(24.72f, 11.599f)
                lineTo(24.708f, 11.606f)
                lineTo(24.976f, 11.958f)
                close()
                moveTo(24.976f, 11.958f)
                lineTo(25.159f, 12.198f)
                lineTo(25.067f, 12.257f)
                lineTo(24.91f, 12.052f)
                curveTo(24.932f, 12.02f, 24.954f, 11.989f, 24.976f, 11.958f)
                close()
                moveTo(16.711f, 16.049f)
                lineTo(17.278f, 16.454f)
                curveTo(17.188f, 16.452f, 17.096f, 16.451f, 17.002f, 16.448f)
                lineTo(16.902f, 16.446f)
                lineTo(16.703f, 16.052f)
                lineTo(16.711f, 16.049f)
                close()
                moveTo(18.746f, 17.499f)
                lineTo(18.735f, 17.565f)
                lineTo(18.837f, 17.564f)
                lineTo(18.746f, 17.499f)
                close()
                moveTo(21.81f, 17.166f)
                lineTo(21.65f, 16.951f)
                curveTo(21.569f, 16.968f, 21.49f, 16.985f, 21.411f, 17.001f)
                lineTo(21.346f, 17.257f)
                curveTo(21.41f, 17.274f, 21.473f, 17.29f, 21.535f, 17.305f)
                curveTo(21.649f, 17.264f, 21.74f, 17.218f, 21.81f, 17.166f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun KazakhstanPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Large.Kazakhstan,
            contentDescription = "Kazakhstan Flag"
        )
    }
}
